import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { Context as LoginContext } from '../../flows/login/machine/types';
import { Context as SignUpContext } from '../../flows/signUp/machine/types';

interface AuthButtonClickedEventArgs {
  analytics: LoginContext['analytics'] | SignUpContext['analytics'];
}

export const sendAuthButtonClickedEvent =
  (action: string, type: 'login' | 'signup') =>
  ({ analytics }: AuthButtonClickedEventArgs): void => {
    const { currentPage } = analytics;

    void trackEvent({
      name: 'mykiss_auth_button_clicked',
      properties: { action, page: currentPage, type, source: 'authentication' },
    });
  };
